import { render } from "./ExpiryBoard.vue?vue&type=template&id=ee59de96&scoped=true"
import script from "./ExpiryBoard.vue?vue&type=script&lang=js"
export * from "./ExpiryBoard.vue?vue&type=script&lang=js"

import "./ExpiryBoard.vue?vue&type=style&index=0&id=ee59de96&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee59de96"]])

export default __exports__